import { useEffect, useState } from "react";
import { SlideDeck, SlidesHeader } from "./slides/SlideDeck";
import { slidesMeta } from "./slides/components/SlideData";

export default function SlidesPage() {
  const [active, setActive] = useState(0);
  const [presentationMode, setPresentationMode] = useState(false);

  const goPrevious = () => setActive((i) => Math.max(i - 1, 0));
  const goNext = () => setActive((i) => Math.min(i + 1, slidesMeta.length - 1));

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (["ArrowRight", " ", "PageDown"].includes(event.key)) goNext();
      if (["ArrowLeft", "PageUp"].includes(event.key)) goPrevious();
      if (event.key === "Escape") setPresentationMode(false);
    };
    const onFullscreenChange = () => {
      if (!document.fullscreenElement) setPresentationMode(false);
    };
    window.addEventListener("keydown", onKey);
    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => {
      window.removeEventListener("keydown", onKey);
      document.removeEventListener("fullscreenchange", onFullscreenChange);
    };
  }, []);

  const enterPresentation = async () => {
    setPresentationMode(true);
    await document.documentElement.requestFullscreen?.().catch(() => undefined);
  };

  return (
    <main className={`relative min-h-screen overflow-hidden px-2 pb-2 sm:px-4 ${presentationMode ? "pt-0 pb-0 sm:pt-2 sm:pb-2" : "pt-16 sm:pb-10 lg:pt-24"}`}>
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[#0a0a19]" />
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_18%_10%,rgba(34,211,238,0.13),transparent_34%),radial-gradient(circle_at_78%_0%,rgba(139,92,246,0.18),transparent_34%)]" />

      {!presentationMode && <SlidesHeader onPresent={enterPresentation} />}
      <SlideDeck
        active={active}
        presentationMode={presentationMode}
        onPrevious={goPrevious}
        onNext={goNext}
        onSelect={setActive}
      />
    </main>
  );
}
